var styles = {"baseHeading":"base-heading--base-heading","body":"base-heading--body","left":"base-heading--left","center":"base-heading--center"};

export { styles as default };
//# sourceMappingURL=BaseHeading.module.esm.js.map
